export const paginationMixin = (page_size = 48) => ({
    count: 0,
    page: 1,
    page_size,
})

export const emptyMediaMixin = (num_placeholder = 0) => ({
    results: Array.from({length: num_placeholder}, (_, i) => ({
        id: i,
        is_placeholder: true
    })),
    pagination: {
        "total": 0,
        "page_size": 40,
        "page_number": 1,
        "num_pages": 1
    }
})
